import { MouseEvent, useRef, useState } from 'react'
import { Back } from '../../../components/buttons/backButton/Back'
import { TuningCard } from '../../../components/tuning/tuningCard/TuningCard'
import { translations } from '../../../configs/translations'
import { Vehicle } from '../../../models/Vehicle'
import { useStore } from '../../../store/store'
import './TuningRoulette.css'

interface TuningRouletteProps {
	selectedVehicle?: Vehicle | null
	items: { name: string; image: string; isDonate?: boolean; onClick: () => void }[]
	onBack?: () => void
}

export const TuningRoulette = ({
	selectedVehicle,
	items,
	onBack,
}: TuningRouletteProps) => {
	const [isDragging, setIsDragging] = useState(false)
	const [startX, setStartX] = useState(0)
	const [scrollLeft, setScrollLeft] = useState(0)
	const rouletteRef = useRef<HTMLDivElement>(null)
	const language = useStore(
		state => state.language
	) as keyof typeof translations
	const t = translations[language]

	const handleMouseDown = (e: MouseEvent) => {
		setIsDragging(true)
		if (rouletteRef.current) {
			setStartX(e.pageX - rouletteRef.current.offsetLeft)
			setScrollLeft(rouletteRef.current.scrollLeft)
		}
	}

	const handleMouseMove = (e: MouseEvent) => {
		if (!isDragging) return
		e.preventDefault()
		if (rouletteRef.current) {
			const x = e.pageX - rouletteRef.current.offsetLeft
			const walk = (x - startX) * 1.1
			rouletteRef.current.scrollLeft = scrollLeft - walk
		}
	}

	const handleMouseUp = () => {
		setIsDragging(false)
	}

	const handleMouseLeave = () => {
		setIsDragging(false)
	}

	return (
		<div className='tuning-roulette-main-container'>
			{onBack && (
				<Back
					onClick={() => {
						onBack()
					}}
					containerStyles={{
						backgroundColor: 'rgba(255, 255, 255, 1)',
						padding: '20px',
						color: '#000',
						gap: '10px',
					}}
					imgStyle={{
						filter: 'brightness(0)',
					}}
				/>
			)}
			<div
				className='tuning-roulette'
				ref={rouletteRef}
				onMouseDown={handleMouseDown}
				onMouseMove={handleMouseMove}
				onMouseUp={handleMouseUp}
				onMouseLeave={handleMouseLeave}
			>
				{items.map(item => (
					<TuningCard
						name={item.name}
						image={item.image}
						isDonate={item.isDonate}
						onSelect={item.onClick}
					/>
				))}
			</div>
		</div>
	)
}
